export default {
  GETTERS: {
    GET_PRODUCT_PRICE: 'PRODUCT_LIST/GET_PRODUCT_PRICE',
  },
  MUTATIONS: {
    SET_PRODUCT_PRICE: 'PRODUCT_LIST/SET_PRODUCT_PRICE',
  },
  ACTIONS: {
    CHANGE_PRICES: 'PRODUCT_LIST/CHANGE_PRICES'
  }
}
